<template>
  <div>
    <div class="wish" v-for="(item, index) in list" :key="index">
      <!-- 信息展示 -->
      <div class="review_top">
        <div class="review_left">
          <img :src="item.user.avatar" />
        </div>
        <div class="review_center">
          <span class="review_name">{{ item.user.nick }}</span>
          <span class="review_address"
            >{{ item.wish.city }}·{{ item.wish.area }}</span
          >
        </div>
        <div class="review_time">{{ item.wish.add_time }}</div>
      </div>
      <div class="review_main">
        {{ item.wish.content }}
      </div>
      <div class="review_bottom" v-if="item.imglist.length > 0">
        <div v-for="i in item.imglist" :key="i.id">
          <img v-if="i.type === 1" :src="i.file_url" />
          <video v-if="i.type === 2" :src="i.file_url"></video>
        </div>
      </div>
      <Button :button="button" @click.native="confirmWish(item.wish.id)" />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
export default {
  props: ["list"],
  components: {
    Button,
  },
  created() {},
  data() {
    return {
      button: "认领心愿",
    };
  },
  methods: {
    confirmWish(id) {
      let data = {
        wishid: id,
      };
      this.$dialog
        .confirm({
          message: "确定认领该心愿吗",
        })
        .then(() => {
          this.$api.claimWish(data);
          this.$toast("认领成功");
          this.$emit("refresh");
        });
    },
  },
};
</script>
<style lang="scss">
/* 信息展示 */
.wish {
  position: relative;
  width: 345px;
  background-color: #ffffff;
  box-shadow: 1px 2px 6px 0px rgba(230, 0, 18, 0.1);
  border-radius: 8px;
  z-index: 1;
  margin: -49px auto 0;
  padding-bottom: 8px;

  .review_top {
    display: flex;
    padding: 9.5px 15px 0 10px;
    align-items: center;
    .review_left {
      width: 33px;
      height: 33px;
      img {
        width: 33px;
        height: 33px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .review_right {
      width: 56px;
      height: 7.5px;
      font-size: 10px;
      line-height: 11.5px;
      color: #666666;
      opacity: 0.7;
    }
    .review_center {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-left: 4px;
      text-align: left;
      .review_name {
        font-size: 14px;
        line-height: 1;
        color: #666666;
        margin-top: 2px;
        margin-bottom: 4px;
      }
      .review_address {
        font-size: 10px;
        line-height: 1;
        color: rgba(102, 102, 102, 0.7);
      }
    }
    .review_time {
      font-size: 10px;
      color: rgba(102, 102, 102, 0.7);
    }
  }
  .review_main {
    width: 284px;
    font-size: 12px;
    line-height: 1.4;
    letter-spacing: 0.5px;
    color: #666666;
    margin-left: 47.5px;
    text-align: left;
    margin-top: 13px;
  }
  .review_bottom {
    width: 283px;
    height: 55px;
    display: flex;
    justify-content: space-between;
    margin-left: 48px;
    margin-top: 9.5px;
    img {
      width: 91px;
      height: 55px;
    }
  }
}
.wish {
  .btn {
    width: 130px;
    height: 30px;
    margin-top: 20px;
    span {
      font-size: 15px;
    }
  }
}
</style>
